var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "lpu-rating-stat d-flex flex-column ga-2",
      attrs: { "data-qa": "lpu_rating_stat" },
    },
    [
      _c("div", { staticClass: "d-flex justify-space-between align-center" }, [
        _c("span", { staticClass: "text-body-2 text-secondary--text" }, [
          _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
        ]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "text-body-2",
            class: _setup.isInactive ? "disabled--text" : "text--text",
          },
          [_vm._v("\n      " + _vm._s(_setup.formattedValue) + "\n    ")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "lpu-rating-stat__bar" }, [
        _c("div", {
          staticClass: "lpu-rating-stat__progress",
          class: { "lpu-rating-stat__progress--inactive": _setup.isInactive },
          style: { width: `${_setup.progressPercent}%` },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }